import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { useHook } from '../../hook'
import { ApproveManyTumModal } from '../ApproveManyTumModal'
import { FilterLayout } from '../Filter'
import { ENewTumRegisterStatus } from '../../type'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { PermissionEnum } from 'app/common/enum'

interface ApproveUnionMembersTableProps {
  status: string
}

const ApproveUnionMembersTable = ({
  status,
}: ApproveUnionMembersTableProps) => {
  const {
    columns,
    pagination,
    filter,
    onChangeFilter,
    handleChangePagination,
    isLoading,
    data,
    tumSelected,
  } = useHook({ status })

  const { verifyPermission } = useVerifyPermission()
  return (
    <BaseSpace size={4}>
      <BaseRow gutter={16} justify={'space-between'} align={'middle'}>
        <BaseCol xl={15}>
          <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />
        </BaseCol>
        {status === ENewTumRegisterStatus.WAITING &&
        verifyPermission(PermissionEnum.ApproveNewTumRegister) ? (
          <BaseCol>
            <ApproveManyTumModal tums={tumSelected ?? []} />
          </BaseCol>
        ) : null}
      </BaseRow>
      <BaseTableManagement
        columns={columns}
        dataSource={data}
        pagination={{
          ...pagination,
          total: pagination.total,
          showTotal: total => (
            <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
          ),
          showSizeChanger: true,
        }}
        loading={isLoading}
        onChange={handleChangePagination}
        rowClassName="row-overwrite-style"
      />
    </BaseSpace>
  )
}

export default ApproveUnionMembersTable
